import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import MenuIcon from '@mui/icons-material/Menu';

import Geocoder from './Geocoder';
import { getSidebar, setSidebar } from '../reducers/sidebar';

import logo from '../assets/cincinnati-logo.png';
import title from '../assets/cincinnati-title.png';

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: 2000,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#006458 !important',
  },
  leftSide: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginTop: 10,
    width: 150,
    verticalAlign: 'top',
  },
  logo: {
    marginTop: 2,
    marginLeft: 8,
    width: 50,
  },
  logoTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuButtonWrapper: {
    width: 56,
    color: 'white',
  },
  menuButton: {
    marginRight: 36,
  },
  geocoderWrapper: {
    zIndex: 3000,
  },
}));

const AppHeader = () => {
  const sidebar = useSelector(getSidebar);
  const dispatch = useDispatch();

  const classes = useStyles();

  const handleHamburgerClick = () => dispatch(setSidebar(!sidebar));

  return (
    <AppBar
      position="absolute"
      className={classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        <div className={classes.leftSide}>
          <div className={classes.menuButtonWrapper}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleHamburgerClick}
              className={classes.menuButton}
            >
              <MenuIcon id="sidebar-toggle" />
            </IconButton>
          </div>

          <div className={classes.logoTitleWrapper}>
            <Link to="/">
              <img className={classes.title} src={title} alt="" />
              <img className={classes.logo} src={logo} alt="Lgo" />
            </Link>
            <Typography variant="h5" sx={{ marginLeft: 2 }}>and Hamilton County Priority Planting</Typography>
          </div>
        </div>
        <div className={classes.geocoderWrapper}>
          <Geocoder />
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
